import { useSelector } from 'react-redux'
import { Outlet, Navigate } from 'react-router-dom'

const ProtectedRoute = () => {
  const siteUser = useSelector((store) => store.user)
  // console.log(siteUser)
  const token = localStorage.getItem('token')
  if (!token) {
    return <Navigate to="/login" replace />
    // return token ? <Outlet /> : <Navigate to="/login" />
  } else if (siteUser?.user?.has_subscription) {
    return <Outlet />
  } else {
    return <Navigate to="/subscription" replace />
  }
}
const ProtectedRoute1 = () => {
  const token = localStorage.getItem('token')
  return token ? <Navigate to="/" /> : <Outlet />
}
export { ProtectedRoute, ProtectedRoute1 }
